import React, { ReactNode } from 'react'

export default function ShowHideSpanMobile({ mobileContent, desktopContent }: { mobileContent: ReactNode; desktopContent :ReactNode}) {
  return (
	<>
		  <span className="md:hidden">{mobileContent}</span>
		  <span className="hidden md:block">{desktopContent}</span>
	</>
  )
}
